import PlaysDashboard from './PlaysDashboard';

export default PlaysDashboard;
